const config = {
    backend_url: /*'http://genplan/'*/'http://genplan.m2o2.ru/',
}
export default config